// Biblioteca
import cn from 'classnames';
import DB from './../global/DB/DB';
import toPriceValue from './../useful/formatter';

import Payment from './Payment/Payment'; // Componentes

// IMGs
import PlusIcon from './../../img/plus-icon-2.svg';
import MinusIcon from './../../img/minus-icon.svg';
import RemoveIcon from './../../img/remove-icon.svg';

import './Cart.css'; // CSS

function Cart(props){
    const {
        cart,
        getTotals,
        onMarkPaymentOption,
        showCreditCardMessage,
        onClose,
        onRemoveProduct,
        onIncreaseProductQuantity,
        onDecreaseProductQuantity,
        onEndOrder
    } = props;

    const products = cart.products;
    const isEmpty = products.length? false : true;
    const totals = getTotals(cart.products);

    function submitCart() {
        const hasPaymentOptionMarked = cart.paymentOptions.find(opt => opt.mark == true);
        
        if(hasPaymentOptionMarked) onEndOrder();
        else alert("Por favor, escolha uma forma de pagamento");
    }
    
    return (
        <div className={cn("cart", {"cart--show": cart.show})}>
            <div className="cart__body">
                {isEmpty? (
                    <div className="cart__empty-cart">
                        <span>Sua sacola está vazia :(</span>
                    </div>
                ) : (
                    <>
                        <div className="cart__limiter">
                            <div className="cart__products">
                                {products.map(product => {
                                    const unityPrice = Object.keys(product.options).reduce((total, optName) => {
                                        const markedOpt = product.options[optName].values.find(opt => opt.mark == true);
                                        const hasMarkedOption = markedOpt != undefined;

                                        if(!hasMarkedOption)
                                            return total;
                                        
                                        return total + (markedOpt.price || 0);
                                    }, 0);
                                    
                                    const totalPrice = unityPrice * product.quantity;

                                    return (
                                        <div className="cart__product">
                                            <div className="cart__product-top">
                                                <div className="cart__product-content">
                                                    <div className="cart__product-name">{product.name}</div>

                                                    <div className="cart__product-list">
                                                        {DB().getProductMarkedOptions(product.options).map(option => (
                                                            <div className="cart__product-item">
                                                                <span className="cart__product-label">{option.optionText}:</span>
                                                                <span className="cart__product-value">{option.markedOption.value}</span>
                                                            </div>
                                                        ))}

                                                        <div className="cart__product-item cart__product-item--margin">
                                                            <span className="cart__product-label">Preço </span>
                                                            <span className="cart__product-value">R$ {toPriceValue(unityPrice)}</span>
                                                        </div>

                                                        <div className="cart__product-item">
                                                            <span className="cart__product-label">Total </span>
                                                            <span className="cart__product-value">R$ {toPriceValue(totalPrice)}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                                
                                                <div className="cart__product-options">
                                                    <div className="cart__product-option">
                                                        <div className="quantifier__content">
                                                            <span className="quantifier__button" onClick={() => onIncreaseProductQuantity(product.id)}>
                                                                <img src={PlusIcon} />
                                                            </span>

                                                            <span className="quantifier__value">
                                                                {product.quantity}
                                                            </span>

                                                            <span className="quantifier__button" onClick={() => onDecreaseProductQuantity(product.id)}>
                                                                <img src={MinusIcon} />
                                                            </span>
                                                        </div>

                                                        <span className="cart__product-button-label">quanti.</span>
                                                    </div>

                                                    <div className="cart__product-option">
                                                        <div className="cart__option-button" onClick={() => onRemoveProduct(product.id)}>
                                                            <img src={RemoveIcon} />
                                                        </div>

                                                        <span className="cart__product-button-label">excluir</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                })}
                            </div>

                            <div className="cart__total">
                                <div className="cart__total-line">
                                    <span className="cart__total-label">Total de itens</span>
                                    <span className="cart__total-value">{totals.quantity}</span>
                                </div>

                                <div className="cart__total-line">
                                    <span className="cart__total-label">Total da compra</span>
                                    <span className="cart__total-value">R$ {toPriceValue(totals.price)}</span>
                                </div>
                            </div>

                            <Payment
                                options={cart.paymentOptions}
                                onMarkOption={onMarkPaymentOption}
                                showCreditCardMessage={showCreditCardMessage} />
                        </div>
                    </>
                )}
            </div>

            <div className="cart__footer">
                <div className="cart__footer-limiter">
                    <div className="orange-button-light" onClick={onClose}>Voltar</div>

                    {isEmpty? "" : (
                        <div className="orange-button" onClick={submitCart}>
                            Finalizar pedido
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}

export default Cart;